module.exports = __webpack_public_path__ + "img/wzf_11.c450266b.png";